module.exports = "<div> FIXME: slider.html is missing </div> ";